import type { ModuleId } from '../../core/store';
import type { IconName } from '../../ui/icons';

export interface ModuleInfo {
  title: string;
  icon: IconName;
  lead: string;
}

export const MODULE_INFO: Record<ModuleId, ModuleInfo> = {
  gitar: {
    title: 'Duyduğunu Çal',
    icon: 'pick',
    lead: 'Uygulama çalar, sen gitarda bulursun. Mikrofon her notayı dinler ve nerede yanıldığını söyler.',
  },
  nota: {
    title: 'Nota Tanıma',
    icon: 'note',
    lead: 'Duyduğun notanın adını bil, adını bildiğin notayı sapta anında bul.',
  },
  vokal: {
    title: 'Vokal & Şan',
    icon: 'voice',
    lead: 'Nefes, duruş ve perde doğruluğu. Söylediğin her notayı canlı grafikte gör.',
  },
  akor: {
    title: 'Akor Kulağı',
    icon: 'chordbox',
    lead: 'Solo çalabiliyorsan sıra akorlarda: şarkıların akorlarını kulaktan bul ve baştan sona çal.',
  },
};

/** Section names used in back links and exercise headers. */
export const MODNAME: Record<string, string> = {
  gitar: 'Duyduğunu Çal',
  nota: 'Nota Tanıma',
  vokal: 'Vokal & Şan',
  akor: 'Akor Kulağı',
  araclar: 'Araçlar',
};
